module.exports = __webpack_public_path__ + "static/img/P1_gray.9ad0d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P1_gray.png
// module id = EKI8
// module chunks = 0